import React, { useEffect } from 'react';
import useCallApi from '../../../../hooks/useCallApi';
import useRequired from '../../../../hooks/useRequired';
import Loading from '../../components/controls/Loading';
import ButtonInfo from './ButtonInfo';
import InputControlMask from './InputControlMask';
import Select from 'react-select';

const DropDown = ({
    id,
    field = '',
    fieldSelect = '',
    label,
    type = 'text',
    placeholder = '',
    value = '',
    valueReadOnly = false,
    classNameContainer = '',
    classNameInput = '',
    onChange = () => '',
    onChangeSelect = () => '',
    valueSelect = '',
    dataProvider = [],
    mask = '',
    pattern = undefined,
    title = '',
    classLabel = '',
    isrequired = false,
    textFormatter = undefined,
    useIconInfo = false,
    containBlank = false,
    typeImgInfo = '', Load = false, useDesc = false
}) => {



    const { data, loading } = useCallApi(dataProvider);
    const cssClassContainer = `${classNameContainer}`;
    const sinAsignar = [{ value: '', text: 'Seleccione' }];
    const dataMatch = [...sinAsignar, ...data];
    const result = containBlank ? dataMatch : data;

    

    const changeHandler = (e) => {
        // debugger;
        let event = { target: {} };
        event.target.value = e.value;
        event.target.name = field;
        event.target.desc = e.text;
        if (e.value)
            onChangeSelect(event);
    }

    const customStyles = {
        option: (provided, state) => {
            return {
                ...provided,
                fontSize: '13px',
                padding: '4px 12px',
                backgroundColor: state.isSelected ? "#008964" : "white",

            }
        },
        indicatorSeparator: (provided, state) => { },
        indicatorsContainer: (provided, state) => {
            // console.log(provided);
            // console.log(state);
            return {
                ...provided,
                height: 27,
                padding: 0,

            }
        },
        control: (provided, state) => {

            return {
                ...provided,
                minHeight: 20,
                border: state.isFocused ? "1px solid #e4e4e4" : "1px solid #e4e4e4",
                height: 30,
                width: "100%",
                fontSize: '13px',
                backgroundColor: '#f7f7f7',
                borderRadius: 0,
                borderColor: state.isFocused && "",
                boxShadow: state.isFocused ? 0 : 0,
                "text-align-last": "center",
                "outline-style": state.isFocused ? "none" : "",
                "border-left": state.isFocused ? "2px solid #008964" : "2px solid #e4e4e4",
                "border-bottom": state.isFocused ? "1px solid #bae6da" : "",
                "border-top": state.isFocused ? "1px solid #bae6da" : "",
                "border-right": state.isFocused ? "1px solid #bae6da" : "",
                '&:hover': {
                    border: '0 !important',
                    "outline-style": "none !important",
                    "border-left": "2px solid #008964 !important",
                    "border-bottom": "1px solid #bae6da !important",
                    "border-top": "1px solid #bae6da !important",
                    "border-right": "1px solid #bae6da !important",
                },
                selectProps: {
                    backgroundColor: "#008964",
                }
            }
        },
        menu: (provided, state) => {
            return {
                ...provided,
                borderRadius: 0,
            }
        },
        placeholder: (provided, state) => {
            return {
                ...provided,
                "text-align": "center",
            }
        },
        singleValue: (provided, state) => {
            return {
                ...provided,
                opacity: state.isDisabled ? 0.5 : 1,
                transition: 'opacity 300ms',
                //color: '#008964',
            }
        },
    }

    /*  <select name={fieldSelect} className="input-select" id={id} value={valueSelect} onChange={onChangeSelect}   required={isrequired}>
                       {data && result.map((item, i) => <option key={i} value={item.value}>{textFormatter != undefined ? textFormatter(item) : item.text}</option>)}
                    </select>*/

    return (
        <div className={cssClassContainer}>

            <div className="lbl-input">

                <span> {label} </span>

            </div>

            <div className="control-input-with-btn">
                {<Select
                    className='w100'
                    name={field}
                    options={containBlank ? [...sinAsignar, ...dataProvider] : dataProvider}
                    isLoading={Load}
                    getOptionLabel={(x) => useDesc ? x.description : x.text}
                    getOptionValue={(x) => x.value}
                    required={isrequired}
                    value={dataProvider.find(x => x.value == valueSelect) != null ? dataProvider.find(x => x.value == valueSelect) : null}
                    styles={customStyles} placeholder="Seleccione" onChange={changeHandler}></Select>
                }{useIconInfo === true && (<ButtonInfo type={typeImgInfo} />)}
                
            </div>
            <input
                className ="input-required"
                    value={valueSelect}
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0 }}
                    required={isrequired}
                />
        </div>
    );

}

export default DropDown;